import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { cultureCodeEnglish, cultureCodeFinnish, cultureCodeSwedish } from "../models/common/consts";

import en from "./en.json";
import fi from "./fi-FI.json";
import sv from "./sv.json";

export const defaultLanguage = cultureCodeFinnish;

export const defaultNamespace = "default";

export const resources = {
    "en": {
        [defaultNamespace]: en,
    },
    "en-US": {
        [defaultNamespace]: en,
    },
    "fi": {
        [defaultNamespace]: fi,
    },
    "sv": {
        [defaultNamespace]: sv,
    },
};

void i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        defaultNS: defaultNamespace,
        ns: [defaultNamespace],
        resources,
        fallbackLng: defaultLanguage,
        supportedLngs: [
            cultureCodeFinnish,
            cultureCodeEnglish,
            cultureCodeSwedish,
            "en"
        ],
        nonExplicitSupportedLngs: true,
        interpolation: {
            escapeValue: false,
        },
    });
